import { AiFillGithub, AiOutlineMail } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

export const SOCIAL_LINKS = [
  { href: "mailto:maanasa@seas.upenn.edu",                   Icon: AiOutlineMail, label: "Email"    },
  { href: "https://github.com/MaanaRajesh",                  Icon: AiFillGithub,  label: "GitHub"   },
  { href: "https://www.linkedin.com/in/maanasa-rajeshwer/",  Icon: FaLinkedinIn,  label: "LinkedIn" },
];
